package com.patronat.top.ui.organisms.location

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.unit.dp
import com.patronat.top.ui.atoms.inputs.InputState
import com.patronat.top.ui.molecules.inputs.AppInput
import com.patronat.top.ui.theme.MineShaft100
import com.patronat.top.ui.theme.MineShaft950
import com.patronat.top.ui.theme.Primary100
import com.patronat.top.ui.theme.Primary600
import com.patronat.top.ui.theme.VenueInputLabelText
import com.patronat.top.ui.theme.VenueSectionTitleText
import com.patronat.top.ui.theme.White

@Composable
fun LocationSection(
    address: String,
    onAddressChange: (String) -> Unit,
    modifier: Modifier = Modifier,
    title: String = "Місцезнаходження",
    leadingIcon: Painter? = null,
    addressLabel: String = "Адреса",
    addressPlaceholder: String = "Введіть адресу",
    addressState: InputState? = null,
    suggestionsContent: (@Composable () -> Unit)? = null,
    mapContent: (@Composable () -> Unit)? = null
) {
    Column(
        modifier = modifier
            .fillMaxWidth()
            .background(White, RoundedCornerShape(12.dp))
            .border(1.dp, MineShaft100, RoundedCornerShape(12.dp))
            .padding(16.dp)
    ) {
        // Header with icon and title
        Row(verticalAlignment = Alignment.CenterVertically) {
            if (leadingIcon != null) {
                Box(
                    modifier = Modifier
                        .size(36.dp)
                        .background(Primary100, RoundedCornerShape(8.dp)),
                    contentAlignment = Alignment.Center
                ) {
                    Icon(
                        painter = leadingIcon,
                        contentDescription = null,
                        modifier = Modifier.size(18.dp)
                    )
                }
                Spacer(modifier = Modifier.size(8.dp))
            }

            Text(
                text = title,
                style = VenueSectionTitleText,
                color = MineShaft950
            )
        }

        Spacer(modifier = Modifier.height(18.dp))

        // Generic address input
        AppInput(
            label = addressLabel,
            labelTextStyle = VenueInputLabelText,
            value = address,
            onValueChange = onAddressChange,
            placeholder = addressPlaceholder,
            forceState = addressState
        )

        // Address suggestions (slot for specific implementation)
        suggestionsContent?.let {
            Spacer(modifier = Modifier.height(8.dp))
            it()
        }

        // Map content (slot for specific implementation)
        mapContent?.let {
            Spacer(modifier = Modifier.height(16.dp))
            it()
        }
    }
}
